import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewDetailsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ViewDetails",
    children: /*#__PURE__*/_jsx("path", {
      d: "m29.71 28.56-4.08-4.23a5.71 5.71 0 0 0-4.62-9.05c-3.14 0-5.7 2.56-5.7 5.7s2.55 5.7 5.7 5.7c1.22 0 2.37-.38 3.35-1.08l4.14 4.16c.17.15.38.23.61.23.52.02.91-.33.89-.81 0-.22-.16-.48-.29-.62m-8.68-3.68c-2.14 0-3.87-1.75-3.87-3.88s1.74-3.88 3.88-3.88 3.88 1.75 3.88 3.89-1.75 3.87-3.89 3.87m-7.68.23H5.94c-.93 0-1.69-.77-1.69-1.7V5.95c0-.93.74-1.7 1.69-1.71h13.71c.93 0 1.69.77 1.69 1.7v6.44c0 .54.59.92 1.13.92.73 0 1.11-.46 1.11-.89V5.95c0-2.17-1.76-3.93-3.93-3.94H5.94C3.76 2.01 2 3.77 2 5.95v17.5c0 2.18 1.76 3.94 3.94 3.94h7.41c.79 0 1.33-.34 1.33-1.12 0-.87-.61-1.16-1.33-1.16m6.28-17.3c0-.49-.4-.89-.89-.89H6.85c-.49 0-.89.4-.89.89s.4.89.89.89h11.9c.49 0 .89-.4.89-.89Zm-3.04 5.32c0-.49-.4-.89-.89-.89H6.85c-.49 0-.89.4-.89.89s.4.89.89.89h8.85c.49 0 .89-.4.89-.89m-9.75 4.44c-.49 0-.89.4-.89.89s.4.89.89.89h6.43c.49 0 .89-.4.89-.89s-.4-.89-.89-.89z"
    })
  }));
};